import TypeSelector from "./type-selector";

export default TypeSelector;
